export default __webpack_public_path__ + "static/media/macbook_air.24669a56.svg";